import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import CustomCheckBox from '@/components/CustomCheckBox';
import { Button, Drawer, Input } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useWidth, { IBooleanArgs } from '@/helpers/widthUtil';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { getLandingNotesCourses, setNotesData } from '@/actions/notes';
import { Dispatch } from 'redux';
import { INotes } from 'src/interfaces/notes';

const NoteSidebar: FC<{ categories: object | any }> = ({ categories }) => {
  const { isMobile }: IBooleanArgs = useWidth();
  const dispatch: Dispatch = useDispatch();
  const [name, setName] = useState<string>('');
  const [category, setCategory] = useState<string>('');
  const [searchDrawer, setSearchDrawer] = useState<boolean>(false);
  const { courseQuery }: { courseQuery: INotes['query']['noteCoursesLanding'] } =
    useSelector((state: RootStateOrAny) => ({
      courseQuery: state?.notes?.query?.noteCoursesLanding,
    }));
  const NUM_COUNT = 2;

  const SLICE_COUNT: number = NUM_COUNT;
  const [catToShow, setCatToShow] = useState<number>(SLICE_COUNT);

  useEffect(() => {
    return () => {
      setSearchDrawer(false);
    };
  }, []);

  const onChange = (
    e: ChangeEvent<HTMLInputElement>,
    key: string,
    value: string
  ): void => {
    key === 'category'
      ? setCategory(e.target.checked ? value : null)
      : setName(value);
    let query: object;
    if (e.target.checked || key === 'name') {
      query = { ...courseQuery, [key]: value };
    } else {
      query = { ...courseQuery };
      delete query[key];
    }
    dispatch(
      setNotesData({
        name: 'query',
        key: 'noteCoursesLanding',
        value: { ...query },
      })
    );
    dispatch(getLandingNotesCourses(query));
    setSearchDrawer(false);
  };

  const resetFilter = (): void => {
    setCategory(null);
    setName('');
    dispatch(
      setNotesData({
        name: 'query',
        key: 'noteCoursesLanding',
        value: {
          page: 1,
          per_page: 10,
        },
      })
    );
    dispatch(
      getLandingNotesCourses({
        page: 1,
        per_page: 10,
      })
    );
    setSearchDrawer(false);
  };

  const showCheckBox = (data: object | any, key: number): JSX.Element => (
    <CustomCheckBox
      className="course-checkbox"
      label={
        <span className="text-capitalize text-black font-weight-500">
          {data.name} ({data?.count})
        </span>
      }
      overlaystyle={{ width: '16px', height: '16px' }}
    >
      <input
        type="checkbox"
        id={`${key}`}
        onChange={(e) => onChange(e, 'category', data.id)}
        checked={category === data.id ? true : false}
      />
    </CustomCheckBox>
  );
  const showSearchBox: JSX.Element = (
    <Input.Search
      value={name}
      className="float-left border-0 mb-4"
      onChange={(e) => onChange(e, 'name', e.target.value)}
      size="large"
      title="Search Courses"
      enterButton
      placeholder="Search Notes"
      onSearch={() => {
        (e) => onChange(e, 'name', e.target.value);
      }}
    />
  );
  const SideBar: JSX.Element = (
    <div className="notes-sidebar">
      <div className="card shadow-none border border-0 mb-2">
        {!isMobile && (
          <div
            className="d-flex justify-content-start mb-3"
            // style={{ border: '2px solid #6d6e80' }}
          >
            <img src="/images/sort.svg" width={'32px'} />
            <h6 className="text-secondary my-auto ml-2">Filters</h6>
          </div>
        )}
      </div>
      {!isMobile && showSearchBox}
      <div>
        <h6 className="mt-3 mb-2 text-secondary">Course Categories</h6>
        <div className="d-flex flex-column">
          {categories?.length <= catToShow
            ? categories?.map((data, key) => showCheckBox(data, key))
            : categories
                ?.slice(0, catToShow)
                ?.map((data, key) => showCheckBox(data, key))}
        </div>
        {categories?.length > NUM_COUNT && catToShow <= categories?.length && (
          <span
            className="cursor-pointer text-black font-weight-500"
            onClick={
              catToShow === SLICE_COUNT
                ? () => setCatToShow(categories?.length)
                : () => setCatToShow(SLICE_COUNT)
            }
          >
            {catToShow === SLICE_COUNT ? (
              <DownOutlined
                rev=""
                className="mr-1"
                style={{ verticalAlign: '-2.15px' }}
              />
            ) : (
              <UpOutlined
                rev=""
                className="mr-1"
                style={{ verticalAlign: '-2.15px' }}
              />
            )}
            Show {catToShow === SLICE_COUNT ? 'more' : 'less'}
          </span>
        )}
      </div>
      <Button
        size={'middle'}
        className="mt-2 mb-1 border-18 w-75 mx-auto"
        onClick={resetFilter}
      >
        <i className="fa fa-times mr-2"></i> Clear filters
      </Button>
    </div>
  );

  return (
    <>
      {!isMobile ? (
        SideBar
      ) : (
        <>
          <div className="d-flex ml-2">
            {showSearchBox}
            <div
              className="justify-content-start px-2 mb-4 m-2 cursor-pointer"
              onClick={() => setSearchDrawer(true)}
              // style={{ border: '2px solid #6d6e80' }}
            >
              <img src="/images/sort.svg" width={'32px'} />
              {/* <h5 className="text-center my-auto ml-2 text-dark">Filters</h5> */}
            </div>
            <Drawer
              width="100%"
              title={<h6 className="text-white">Filters</h6>}
              visible={searchDrawer}
              onClose={() => setSearchDrawer(false)}
            >
              {SideBar}
            </Drawer>
          </div>
        </>
      )}
    </>
  );
};

export default NoteSidebar;
